import axios from 'axios'
import { getCookie, getLocalstorage, clearLocalstorages, setLocalstorage } from '@/utils/index'

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/micro' : '',
  timeout: 180 * 1000
})

service.interceptors.request.use(
  async config => {
    config.headers['x-token'] = getCookie('x-token') || getLocalstorage('x-token')
    console.log("getCookie('x-token')", getCookie('x-token'), "getLocalstorage('x-token'", getLocalstorage('x-token'))
    return config
  },
  error => {
    console.log('request', error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    // 中间件用 refreshToken 自动续期后，会把新 accessToken 放在 x-n-token 响应头里。
    // 不接的话 cookie 虽然被后端更新了，但 localStorage 里还是旧 token，
    // 两边不一致（micro-component-card 已经在做这事，portal 之前漏了）。
    const nToken = response.headers['x-n-token']
    if (nToken) {
      setLocalstorage('x-token', nToken)
    }
    const res = response.data
    if (res.code === 401) {
      clearLocalstorages(['x-token', 'x-r-token'])
      const redirect = window.location.href
      window.location.replace(`/register?redirect=${redirect}`)
    }
    return res
  },
  async (error) => {
    if (error.response?.status === 401) {
      clearLocalstorages(['x-token', 'x-r-token'])
      const redirect = window.location.href
      window.location.replace(`/register?redirect=${redirect}`)
      return
    }
    return Promise.reject(error)
  }
)

export default service
